import React from 'react';
import {
  LegacyCard,
  ResourceList,
  ResourceItem,
  Avatar,
  Text,
  LegacyStack,
  Link,
} from '@shopify/polaris';
import placeholderImg from 'images/placeholder.png';
import type { ShopifyVariant } from '../../../../api_utils/types';

export function LinkedVariants({ shopifyVariants }: {
    readonly shopifyVariants: ShopifyVariant[],
  }): JSX.Element {
  const renderLinkedVariantsItem = (shopifyVariant: ShopifyVariant): React.JSX.Element => {
    let src = placeholderImg;
    if (shopifyVariant.image_src) {
      src = `${shopifyVariant.image_src}&&height=40`;
    }
    return (
      <ResourceItem
        accessibilityLabel={`View details for ${shopifyVariant.title}`}
        external
        id={shopifyVariant.id.toString()}
        key={`${shopifyVariant.id}-linked-variant`}
        media={<Avatar customer={false} size='lg' source={src}/>}
        name={shopifyVariant.title}
        url={shopifyVariant.variant_url}
        verticalAlignment="center"
      >
        <LegacyStack distribution="equalSpacing">
          <LegacyStack.Item>
            <Text as="h4">
              <Link
                monochrome
                removeUnderline
                target="_blank"
              >
                <Text as="span" tone={shopifyVariant.discarded ? "disabled" : "base"}>{shopifyVariant.title}</Text>
              </Link>
            </Text>
            <Text as="span" tone={shopifyVariant.discarded ? "disabled" : "subdued"}>
              {shopifyVariant.shop_domain}
            </Text>
          </LegacyStack.Item>
        </LegacyStack>
      </ResourceItem>
    );
  };

  return (
    <LegacyCard title="Linked variants">
      <LegacyCard.Section>
        <h4>
          To change the linking of variants, just change the SKUs or barcodes of those variants in your Shopify shop.
        </h4>
        {shopifyVariants.length ? (
          <ResourceList
            items={shopifyVariants}
            renderItem={renderLinkedVariantsItem}
          />
        ) : (
          <LegacyCard.Section>
            <Text as="h4" tone="subdued">
              No linked variants available
            </Text>
          </LegacyCard.Section>
        )}
      </LegacyCard.Section>
    </LegacyCard>
  );
}
